import { render, staticRenderFns } from "./Fraud.vue?vue&type=template&id=2dab8895&scoped=true&"
import script from "./Fraud.vue?vue&type=script&lang=ts&"
export * from "./Fraud.vue?vue&type=script&lang=ts&"
import style0 from "./Fraud.vue?vue&type=style&index=0&id=2dab8895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab8895",
  null
  
)

export default component.exports